<template>
  <div :class="[classes.marketCard, 'market-card']">
    <slot />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { createUseStyles } from "@fresh8/ad-data-composition/src/theme";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";

const { useStyles } = createUseStyles(
  {
    marketCard: {
      minWidth: "212px",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      border: props => `1px solid ${props.marketBorderColor}`,
      borderRadius: props => `${props.borderRadius}px`,
      flex: 1,
      boxSizing: "border-box",
      background: props => props.cardBackgroundColor
    }
  },
  { marketBorderColor: "#dcddf" }
);

export default defineComponent({
  name: "StyledMarketCard",
  setup() {
    const { adTemplateBranding } = injectBrand();

    const { classesRef } = useStyles(adTemplateBranding);

    return {
      classes: classesRef
    };
  }
});
</script>
